import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useAuth } from '@/shared/auth/useAuth';
import { env } from '@/shared/config/env';

function BrandMark() {
  return (
    <Box
      aria-hidden
      sx={{
        width: 56,
        height: 56,
        borderRadius: 3,
        display: 'grid',
        placeItems: 'center',
        color: '#fff',
        background: (t) => `linear-gradient(135deg, ${t.palette.primary.light}, ${t.palette.primary.dark})`,
        boxShadow: '0 8px 24px rgba(18, 124, 113, 0.32)',
      }}
    >
      <StorefrontRoundedIcon sx={{ fontSize: 30 }} />
    </Box>
  );
}

/** Public landing / sign-in page shown to unauthenticated visitors. */
export function LandingPage() {
  const { login } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Stack spacing={2.5} alignItems="center" textAlign="center">
            <BrandMark />
            <Box>
              <Typography variant="h4" component="h1">
                {env.appName}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                The back office for companies running an online store on the platform.
              </Typography>
            </Box>

            <Button
              fullWidth
              size="large"
              variant="contained"
              startIcon={<LoginRoundedIcon />}
              onClick={login}
            >
              Sign in
            </Button>

            <Typography variant="body2" color="text.secondary">
              New to the platform?{' '}
              <Box component={RouterLink} to="/sign-up" sx={{ color: 'primary.main', fontWeight: 600 }}>
                Create a company account
              </Box>
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
